import React from 'react';
import {
    IonModal,
    IonContent, IonIcon, IonButton, IonFooter, IonToolbar, IonRow, IonCol, useIonAlert,
} from '@ionic/react';
import {
    businessOutline,
    calendarOutline,
    chevronBackOutline,
    downloadOutline, shareSocialOutline,
} from "ionicons/icons";
import {FacebookLoader} from "./Loader/FacebookLoader";
import moment from "moment-timezone";
import {callFunctionToDownload} from "../lib/downloadHelper";
import {Capacitor} from "@capacitor/core";
import {Share} from "@capacitor/share";

export default function EventDetailModal({ isOpen, onDidDismiss,eventDetailData,openRegisterToEventModal,openTransactionListModal }) {
    const [presentAlert] = useIonAlert();
    const handleShareUrl = async (data) => {
        try {
            const url = `https://caworld.org/api-ca-world/common/shareAppContentData/event/${data?.id}`;
            const title = 'CA World Event';
            const text = 'Check out this event detail!';

            // Prefer native Share plugin when running in a Capacitor app.
            // Don't gate on canShare() for text/URL — it's mainly helpful for FILE sharing.
            const isNative = Capacitor.getPlatform() !== 'web';
            const hasPlugin = Capacitor.isPluginAvailable?.('Share');

            if (isNative && hasPlugin) {
                await Share.share({
                    title,
                    text,
                    url,                  // supports http/https and file://
                    dialogTitle: 'Share this event', // Android only
                });
                return;
            }

            // Web Share API (must be triggered from a direct user gesture)
            if (navigator?.share) {
                await navigator.share({ title, text, url });
                return;
            }

            // Fallbacks
            try {
                await navigator?.clipboard?.writeText?.(url);
                presentAlert({
                    header: 'Error Sharing!',
                    message: 'Link copied to clipboard!',
                    buttons: [{
                        text: 'Ok',
                    }],
                });
            } catch {
                window.prompt('Sharing is not supported. Copy this link:', url);
            }
        } catch (err) {
            console.error('Sharing failed:', err);
            presentAlert({
                header: 'Error Sharing!',
                message: 'Failed to share!',
                buttons: [{
                    text: 'Ok',
                }],
            });
        }
    };
    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            {eventDetailData?.id ? (
                <>
                    <IonContent fullscreen className="news-detail-page">
                        {eventDetailData?.id ? (
                            <>
                                <div className="news-detail-image-wrapper">
                                    <img
                                        src={eventDetailData.image_url}
                                        alt={eventDetailData.title}
                                    />
                                    <div className="news-detail-top-buttons">
                                        {onDidDismiss ? (
                                            <button onClick={onDidDismiss} className="circle-btn">
                                                <IonIcon icon={chevronBackOutline} />
                                            </button>
                                        ) : (
                                            ""
                                        )}
                                        <div className="right-buttons">
                                            <button
                                                onClick={() => callFunctionToDownload(eventDetailData.pdf_url)}
                                                className="circle-btn"
                                            >
                                                <IonIcon icon={downloadOutline} />
                                            </button>
                                            <button onClick={()=>handleShareUrl(eventDetailData)} className="circle-btn">
                                                <IonIcon icon={shareSocialOutline}/>
                                            </button >

                                        </div>
                                    </div>
                                </div>

                                <div className="news-detail-content">
                                    <h2 className="event-title">{eventDetailData.title}</h2>

                                    <h3 className="event-sub-title">{eventDetailData.topic}</h3>
                                    {/* Event Date & Time */}
                                    <div className="event-date-time">
                                        <IonIcon icon={calendarOutline} />{" "}
                                        <div>
                                            {moment(eventDetailData?.event_date_time).format("dddd, Do MMMM, YYYY")} ({moment(eventDetailData?.event_date_time).format("h:mm A")} to {moment(eventDetailData?.event_end_date_time).format("h:mm A")})
                                        </div>
                                    </div>


                                    {/* Venue */}
                                    {eventDetailData.venue && (
                                        <div className="event-location">
                                            <IonIcon icon={businessOutline} /> {eventDetailData.venue}
                                        </div>
                                    )}

                                    {/* Location */}
                                    {eventDetailData.organised_by && (
                                        <div className="event-location-org-by">
                                            <span>Organised By:</span> {eventDetailData?.organised_by}
                                        </div>
                                    )}

                                    <hr/>

                                    {eventDetailData?.experts?.length ? (
                                        <div className="event-experts-container-section">
                                            <div className={"event-expert-heading"}>
                                                Featured Faculty / Subject Matter Experts
                                            </div>
                                            <div className={"event-expert-row_container"}>
                                                {[...(eventDetailData?.experts || [])].reverse().map((experts) => (
                                                    <div key={experts?.id} className="event-expert-row_col">
                                                        <img src={experts?.image_url} className="event-expert-row_col_img" alt={experts?.name} />
                                                        <div className="event-expert-row_col_name">
                                                            {experts?.name}
                                                        </div>
                                                        <div className="event-expert-row_col_deg">
                                                            {experts?.designation}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ):''}

                                    <hr/>

                                    {(eventDetailData?.program_html) ?
                                        <div className="event-program-html-container">
                                            <div className={"event-program-html-heading"}>
                                                Detailed Program
                                            </div>
                                            <div className="event-program-html-description"
                                                 dangerouslySetInnerHTML={{
                                                     __html: eventDetailData.program_html,
                                                 }}
                                            />
                                        </div>
                                        :''
                                    }
                                    <hr/>

                                    <div className="event-program-html-container">
                                        <div className={"event-program-html-heading"}>
                                            Photo Gallery
                                        </div>
                                        {(eventDetailData?.gallery?.length) ?
                                            <div className={"event-photo-gallery-container"}>
                                                {(eventDetailData?.gallery?.map((gallery)=>(
                                                    <div className={"event-photo-gallery-row"} key={gallery?.id}>
                                                        <img src={gallery?.image_url} className={"event-expert-row_col_img"} alt={gallery?.caption}/>
                                                    </div>
                                                )))}
                                            </div>
                                            :
                                            <div className={"event-photo-gallery-container"}>
                                                To be updated
                                            </div>
                                        }
                                    </div>
                                </div>
                            </>
                        ) : (
                            <FacebookLoader type={"facebookStyle"} item={4} />
                        )}
                    </IonContent>
                    <IonFooter className="job_detail_sheet_footer ion-padding">
                        <IonToolbar>
                            <IonRow>
                                <IonCol>
                                    {(eventDetailData?.member_registrations?.length) ?
                                        <IonButton className="apply_job_button" onClick={()=>openTransactionListModal(eventDetailData?.member_registrations)} expand="block">
                                            View
                                        </IonButton>
                                        :
                                        <>
                                            {(moment(eventDetailData.event_date_time).isAfter(moment())) ?
                                                <IonButton onClick={()=>openRegisterToEventModal(eventDetailData)} className="apply_job_button" expand="block">
                                                    Register Now
                                                </IonButton>
                                                :
                                                <IonButton  onClick={() => callFunctionToDownload(eventDetailData.pdf_url)} className="close_job_detail_button" expand="block">
                                                    Download Pdf
                                                </IonButton>
                                            }
                                        </>
                                    }
                                </IonCol>
                                <IonCol>
                                    <IonButton onClick={onDidDismiss} className="apply_job_button" expand="block">
                                        Close
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonToolbar>
                    </IonFooter>
                </>
            ) : (
                ""
            )}
        </IonModal>

    );
}
